module.exports = __webpack_public_path__ + "img/bespoke70_16.1ff66e02.jpg";